module.exports = __webpack_public_path__ + "static/media/upi_logo.b1996762.png";